import { InfoIcon } from '@/components/Icons';
import { R } from '@/features/profile/resources/ProfileResources.resx';
import { Button } from '@/components';
import { cn } from '@/lib/cn';

type ParentalAuthorityWarningProps = {
    onConfirm: () => void;
    onBack: () => void;
    isPending: boolean;
};

export const ParentalAuthorityWarning = ({
    onConfirm,
    onBack,
    isPending,
}: ParentalAuthorityWarningProps) => {
    return (
        <section className="flex flex-col gap-4">
            <div className="border-secondary-red bg-secondary-red-extralight text-secondary-red rounded-2xl border p-4">
                <InfoIcon />
                <main>
                    <p className="font-bold">
                        {R.ParentalAuthorityCannotBeConfirmed}
                    </p>
                    <p>{R.ParentalAuthorityCannotBeConfirmedDescription}</p>
                </main>
            </div>

            <div className="flex justify-end gap-4">
                <Button variant="secondary" onClick={onBack}>
                    {R.Back}
                </Button>
                <Button
                    variant="primary"
                    className={cn({ 'button--loading': isPending })}
                    onClick={onConfirm}
                >
                    {R.ConfirmAndSave}
                </Button>
            </div>
        </section>
    );
};
